import React from 'react';
import { useTranslation } from 'context/LanguageContext';
import { shouldShowQuantity } from 'config/clientConfig';

const StockStatus = ({ quantity, isTracked, isLowStock, isOutOfStock }) => {
  const { t } = useTranslation();

  if (!isTracked) {
    return null;
  }

  return (
    <div className="mb-4">
      <div className="flex items-center justify-between mb-1.5">
        {!isOutOfStock ? (
          <span className={`text-xs font-medium ${isLowStock ? 'text-orange-600' : 'text-green-600'}`}>
            {shouldShowQuantity()
              ? `${quantity} ${t("unitsInStock")}`
              : t("available")}
          </span>
        ) : (
          <span className="text-xs font-medium text-red-600">{t("outOfStock")}</span>
        )}
      </div>
      <div className="w-full bg-gray-200 rounded-full h-1.5">
        <div 
          className={`h-1.5 rounded-full transition-all ${
            isLowStock ? 'bg-orange-500' : 'bg-green-500'
          }`}
          style={{ width: `${Math.min((quantity / 100) * 100, 100)}%` }}
        ></div>
      </div>
    </div>
  );
};

export default StockStatus;
